<template>
  <router-link
    :to="{ name: breadcrumb.name, params: breadcrumb.params, query: breadcrumb.query }"
    >{{ name }}</router-link
  >
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductDetailBreadcrumb',
  props: ['breadcrumb'],
  computed: mapState({
    name: state => state.currentProductName,
  }),
};
</script>
